module.exports = __webpack_public_path__ + "img/garant-img-5.3b682b2d.png";